import React from 'react';
import { Link } from 'react-router-dom';
import { BlogPost } from '../../types';
import './RelatedPosts.css';

interface RelatedPostsProps {
  posts: BlogPost[];
}

const RelatedPosts: React.FC<RelatedPostsProps> = ({ posts }) => {
  if (posts.length === 0) {
    return null;
  }

  return (
    <section className="related-posts">
      <h2 className="related-posts__title">publicaciones recientes</h2>
      
      <div className="related-posts__grid">
        {posts.map((post) => (
          <article key={post.id} className="related-post-card">
            <Link to={`/blog/${post.slug}`} className="related-post-card__link">
              <div className="related-post-card__image-container">
                <img
                  src={post.featuredImage.url}
                  alt={post.featuredImage.alt}
                  className="related-post-card__image"
                  loading="lazy"
                />
              </div>
            </Link>
            
            <div className="related-post-card__content">
              <span className="category-text">{post.category.name}</span>
              <Link to={`/blog/${post.slug}`} className="related-post-card__title-link">
                <h3 className="related-post-card__title">{post.title}</h3>
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default RelatedPosts;